import "./Cloud.css";
import CloudOpt from "../../components/seo/CloudOpt"


export default function CloudRunDeploy() {
    return (
        <>
            <CloudOpt
                title="Cloud Deploy"
                description="This article explains the hosting process of an app in the cloud with the best deployment methods."
                keywords="Cloud, Cloud Techmology, Cloud Computing, Cloud Deployment, Cloud Run, Flask, Hosting"
            />
            <article className="contentCloud">
                <h1 style={{ display: 'flex', justifyContent: 'center' }}>Deploying applications to Google Cloud Run</h1>

                <p>Cloud Run is a platform that let you deploy your code in a scalable infrastructure. It run frontend and backend services, batch jobs, host LLMs, and queue processing workloads without the need to manage infrastructure.</p>
                <p>GitHub let you automate your deployments using builtin CI/CD pipelines.</p>
                <p>By the end, you’ll know how to deploy a web app to Cloud Run directly from GitHub.</p>

                <h2>Prerequisites</h2>
                <p>First, you will need a google cloud account, setup a project and enable billing. A github repository containing your app code.</p>
                <p>If your prefer commands then 'gcloud' CLI installed and properly configured with your credentials and project id.</p>


                <h2>Step 1: Set Your Project Variables</h2>

                <p>Define environment variables for reuse:</p>

                <pre>
                    <code>export PROJECT_ID=your-gcp-project-id</code><br />
                    <code>export SERVICE_NAME=flask-contact-app</code><br />
                    <code>export REGION=us-central1</code><br />
                    <code>export GITHUB_REPO=your-username/your-repo</code><br />
                </pre>

                <h2>Step 2: Authenticate with Google Cloud</h2>

                <pre>
                    <code>gcloud auth login</code><br />
                    <code>gcloud config set project $PROJECT_ID</code>
                </pre>

                <h2>Step 3: Enable Required APIs</h2>

                <pre>
                    <code>gcloud services enable run.googleapis.com</code><br />
                    <code>gcloud services enable cloudbuild.googleapis.com</code><br />
                    <code>gcloud services enable artifactregistry.googleapis.com</code>
                </pre>

                <h2>Step 4: Connect GitHub to Cloud Run</h2>

                <p>You can link GitHub either via the Cloud Run Console or CLI:</p>

                <h3>Console method:</h3>
                <p>1. Go to Cloud Run console</p>
                <p>2. Click Create Service → choose GitHub as source</p>
                <p>3. Authorize Google Cloud to access your GitHub account</p>
                <p>4. Select repository and branch</p>

                <h3>CLI method</h3>
                <pre>
                    <code>gcloud run deploy $SERVICE_NAME \</code><br />
                    <code>      --source https://github.com/$GITHUB_REPO \</code><br />
                    <code>      --region $REGION \</code><br />
                    <code>      --allow-unauthenticated</code>

                </pre>

                <h2>Step 5: Configure Secrets</h2>
                <p>Store sensitive values in Secret Manager:</p>

                <pre>
                    <code>echo -n "your-email@outlook.com" | gcloud secrets create MAIL_USERNAME --data-file=-</code><br />
                    <code>echo -n "your-app-password" | gcloud secrets create MAIL_PASSWORD --data-file=-</code><br />
                    <code>echo -n "recipient@example.com" | gcloud secrets create MAIL_RECEIVER --data-file=-</code>

                </pre>

                <h2>Step 6: Deploy from GitHub</h2>
                <p>Deploy with secrets and resource limits:</p>

                <pre>
                    <code>gcloud run deploy $SERVICE_NAME \</code><br />
                    <code>  --source https://github.com/$GITHUB_REPO \</code><br />
                    <code>  --region $REGION \</code><br />
                    <code>  --allow-unauthenticated \</code><br />
                    <code>  --set-secrets="MAIL_USERNAME=MAIL_USERNAME:latest,MAIL_PASSWORD=MAIL_PASSWORD:latest,MAIL_RECEIVER=MAIL_RECEIVER:latest" \</code><br />
                    <code>  --memory 512Mi \</code><br />
                    <code>  --cpu 1 \</code><br />
                    <code>  --timeout 300 \</code><br />
                    <code>  --max-instances 100</code><br />


                </pre>

                <h2>Step 7: Automatic Deployment</h2>
                <p>Cloud Run can auto‑deploy on every push:</p>
                <p>1. Open your service in the Cloud Run console</p>
                <p>2. Go to Connections tab</p>
                <p>3. Enable auto‑deployment preferences</p>

                <h2>Testing Your Deployment</h2>
                <p>Retrieve the service URL:</p>
                <pre>
                    <code>gcloud run services describe $SERVICE_NAME --region $REGION --format='value(status.url)'
                    </code>
                </pre>
                <p>Send a test request:</p>
                <pre>
                    <code>curl -X POST https://YOUR-SERVICE-URL/contact \</code><br />
                    <code>    -H "Content-Type: application/json" \</code><br />
                    <code>    -d '{`{`}</code><br />
                    <code>        "name": "Test User",</code><br />
                    <code>        "email": "test@example.com",</code><br />
                    <code>        "message": "This is a test message from Cloud Run!"</code><br />
                    <code>        {`}`}'</code><br />
                </pre>

                <h2>Conclusion</h2>
                <p>With GitHub integration, Cloud Run handles builds and deployments automatically. This setup ensures:</p>
                <ul>
                    <li>Secure secrets management</li>

                    <li>Scalable infrastructure with resource limits</li>

                    <li>Continuous deployment triggered by GitHub pushes</li>
                </ul>
                <p>From here, you can extend the workflow with monitoring, logging, and advanced CI/CD pipelines.</p>
            </article>
        </>
    )
}